import * as React from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './state/auth-state';
import { ToastProvider } from './state/toast-state';
import { DomainProvider } from './state/domain-state';
import { SubdomainProvider } from './state/subdomain-state';
import { AssignmentProvider } from './state/assignment-state';
import { CredentialProvider } from './state/credential-state';
import { Toaster } from './components/ui/toast';
import { router } from './routes';

/**
 * Root application component for the Admin Console.
 * Composes providers in the order specified by the architecture diagram:
 * AuthProvider > ToastProvider > DomainProvider > SubdomainProvider > AssignmentProvider > CredentialProvider > RouterProvider
 *
 * State providers are at app level since admin console pages share domain/subdomain context.
 * Toaster renders at root level (outside router) for portal-based toast rendering.
 */
export function App(): React.JSX.Element {
  return (
    <AuthProvider>
      <ToastProvider>
        <DomainProvider>
          <SubdomainProvider>
            <AssignmentProvider>
              <CredentialProvider>
                <RouterProvider router={router} />
                <Toaster />
              </CredentialProvider>
            </AssignmentProvider>
          </SubdomainProvider>
        </DomainProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
